import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function GuaranteeFaqSection() {
  return <>
      <section className="section ink" id="guarantee" data-id="element-70" data-mp="r6r92m9w3brt">
        <div className="wrap" data-id="element-71" data-mp="v7und4cagzqx">
          <div className="guarantee-box" data-id="element-72" data-mp="v6jo9htsgg65">
            <p className="eyebrow" data-id="element-73" data-mp="zyktwkwgb8n7">Your purchase is protected</p>
            <ShieldCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-74" data-mp="1004bqfxr9rr3" />
            <h2 data-id="element-75" data-mp="14xe86fjkb3of">
              10-day <span data-id="element-76" data-mp="1500iuo1r1zav">return window.</span>
            </h2>
            <p data-id="element-77" data-mp="19vxy0r1a0zm2">
              If this isn’t the right fit for your planning style, request a return within 10 days. We’ll help you
              make it right.
            </p>
            <p className="policy-note" data-id="element-78" data-mp="1iy7494pii6tn">This material is recreational in nature and isn’t therapy or medical advice.</p>
          </div>
        </div>
      </section>
      <section className="section light" id="faq" data-id="element-79" data-mp="3gpjm5kqbev71">
        <div className="wrap" data-id="element-80" data-mp="3kq3fsebojgof">
          <div className="faq-wrap" data-id="element-81" data-mp="3kpbwo2z9rbf1">
            <h2 data-id="element-82" data-mp="1fqqke1ayhb46">
              Frequently asked <span className="accent" data-id="element-83" data-mp="1fs1wcoek1p6d">questions.</span>
            </h2>
            {faqs.map(faq => <details key={faq.question} data-id="element-84" data-mp="1azic58ld3vsl">
                <summary data-id="element-85" data-mp="1616zkq3on76o">
                  {faq.question}
                  <span aria-hidden="true" data-id="element-86" data-mp="161p4eb4eutq7">+</span>
                </summary>
                <p data-id="element-87" data-mp="112vsuo8opcso">{faq.answer}</p>
              </details>)}
          </div>
        </div>
      </section>
    </>;
}